import { findRecordsByModelName } from './YhcEstimateFormFrontPage/findRecordsByModelName'
import { ModelFixedHolidays } from '../fireModels/yhcDataTypes'

/**
 * 固定休日に含まれるかどうか
 * @param date
 * @returns
 */

let cachedFixedHolidays: ModelFixedHolidays[] | null = null

/**
 * キャッシュを無効化する（管理画面で固定休日が更新されたときに呼び出す）
 */
export const invalidateFixedHolidaysCache = () => {
  cachedFixedHolidays = null
}

export const judgementFixedHoliday = async (date: Date): Promise<boolean> => {
  if (!date) return false

  // キャッシュが無い場合は取得
  if (cachedFixedHolidays === null) {
    const fixedHolidays = await findRecordsByModelName('fixed_holidays', {
      limit: -1,
    })
    cachedFixedHolidays = fixedHolidays
  }

  return checkIfFixedHoliday(date, cachedFixedHolidays)
}

/**
 * 固定休日判定ロジック
 */
const checkIfFixedHoliday = (
  date: Date,
  fixedHolidays: ModelFixedHolidays[],
): boolean => {
  if (fixedHolidays.length === 0) {
    return false
  }

  // 日付を 'MM-DD' 形式の文字列に変換
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const currentMonthDay = month + '-' + day

  for (const holiday of fixedHolidays) {
    const { start_month_day, end_month_day } = holiday

    if (!start_month_day || !end_month_day) continue

    // 年またぎの場合 (例: 開始が12-30, 終了が01-03)
    if (start_month_day > end_month_day) {
      if (currentMonthDay >= start_month_day || currentMonthDay <= end_month_day) {
        return true
      }
    }
    // 年またぎでない場合 (例: 開始が05-01, 終了が05-05)
    else {
      if (currentMonthDay >= start_month_day && currentMonthDay <= end_month_day) {
        return true
      }
    }
  }

  return false
}
